import React from 'react';
import MainPage from '@components/MainPage';
import LeadGate from '@components/LeadGate';

const ObituaryPage = () => {
  return (
    <>
      <LeadGate />
      <MainPage />
    </>
  );
};

export default ObituaryPage;
